<div class="editAccountUserCustomFields__wrapper">
  <div class="editAccountUserCustomFields__fields">
    <header class="editAccountUserCustomFields__fieldsHeader">
      {{ 'custom_fields' | ppTranslate }}
    </header>

    <section class="editAccountUserCustomFields__fieldsTable">
      @for (
        customField of share.advancedAccessLevels.customFields; track
        customField; let even = $even; let index = $index) {
        @if (checkCFVisibility(customField)) {
          <pp-account-user-modal-custom-field
            [ppCustomField]="customField"
            (ppCustomFieldChange)="updateCustomField(index, $event)"
            [ppWorkspaceId]="ppWorkspaceId"
            [ppShareOption]="share.shareOption"
            [ppEven]="even"
          ></pp-account-user-modal-custom-field>
        }
      }
    </section>
  </div>
</div>
